import { useMutation } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IPartAiTitleResponse } from "../models/Part";

export default function usePartAiTitle() {
  const { post } = useApiHelper();

  const generateAiTitle = useMutation((partId: string) =>
    post<null, IPartAiTitleResponse>(`/part/listing/ai-title/${partId}`, null)
  );

  return {
    generateAiTitle,
  };
}
